<template>
  <div>
    <CCol sm="12">
      <CCard>
        <CCardBody class="d-flex flex-column">
          <!-- Daily summary -->
          <CCol>
            <CRow class="d-flex justify-content-between">
              <label class="">E-mail resumo diário</label>
              <label class="not-active-label" v-if="!dailyEmails || !dailyHour"><span>Desativado</span> (preencha os emails e a hora de envio para ativar)</label>
            </CRow>
          </CCol>
          <CRow class="d-flex">
            <CCol sm="9">
              <CInput placeholder="Emails (separados por vírgulas)" v-model="dailyEmails"/>
            </CCol>
            <CCol sm="3">
              <CInput sm="8" type="time" :step='3600' placeholder="Horário" v-model="dailyHour" :key="'daily' + refreshableKey"/>
            </CCol>
          </CRow>
          <hr/>
          <!-- Weekly summary -->
          <CCol>
            <CRow class="d-flex justify-content-between">
              <label class="">E-mail resumo semanal</label>
              <label class="not-active-label" v-if="!weeklyEmails || !weeklyDay || !weeklyHour"><span>Desativado</span> (preencha os emails e a hora de envio para ativar)</label>
            </CRow>
          </CCol>
          <CRow class="d-flex">
            <CCol sm="6">
              <CInput placeholder="Emails (separados por vírgulas)" v-model="weeklyEmails"/>
            </CCol>
            <CCol sm="3">
              <DropdownFilter title="Dia da semana" :options="dayOfWeekOptions" :defaultOption="savedWeeklyDay" @option-changed="weeklyDayChanged" :index="1"></DropdownFilter>  
            </CCol>
            <CCol sm="3">
              <CInput sm="8" type="time" :step='3600' placeholder="Horário" v-model="weeklyHour" :key="'weekly' + refreshableKey"/>
            </CCol>
          </CRow>
          <hr/>
          <!-- Monthly summary -->
          <CCol>
            <CRow class="d-flex justify-content-between">
              <label class="">E-mail resumo mensal</label>
              <label class="not-active-label" v-if="!monthlyEmails || !monthlyDay || !monthlyHour"><span>Desativado</span> (preencha os emails e a hora de envio para ativar)</label>
            </CRow>
          </CCol>
          <CRow class="d-flex">
            <CCol sm="6">
              <CInput placeholder="Emails (separados por vírgulas)" v-model="monthlyEmails"/>
            </CCol>
            <CCol sm="3">
              <DropdownFilter title="Dia da semana" :options="dayOfWeekOptions" :defaultOption="savedMonthlyDay" @option-changed="monthlyDayChanged" :index="2"></DropdownFilter>  
            </CCol>
            <CCol sm="3">
              <CInput sm="8" type="time" :step='3600' placeholder="Horário" v-model="monthlyHour" :key="'monthly' + refreshableKey"/>
            </CCol>
          </CRow>
          <hr/>
          <!-- Max previous days -->
          <CCol>
            <CRow>
              <label class="">Número máximo de dias para registo no passado</label>
            </CRow>
          </CCol>
          <CRow class="d-flex">
            <CCol sm="12">
              <DropdownFilter title="Número dias" :options="previousDaysOptions" :defaultOption="savedMaxDays" @option-changed="previousDaysChanged" :index="3"></DropdownFilter>  
            </CCol>
          </CRow>
          <!-- Action button -->
          <CCol class="d-flex justify-content-end mt-3">
              <CRow sm="2" class="align-self-end">
                  <CSpinner v-if="loading" variant="success" small></CSpinner>
                  <CButton v-else type="button" class="btn btn-primary" @click="submitClicked">Submeter</CButton>
              </CRow>
          </CCol>
        </CCardBody>
      </CCard>
    </CCol>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import DropdownFilter from '../controls/DropdownFilter.vue';
import Summary from "@/classes/Summary";
import InputSettings from "@/classes/InputSettings";

export default {
  components: { DropdownFilter },
  data () {
    return {
      loading: false,
      previousDays: 0,
      dailyEmails: '',
      dailyHour: null,
      weeklyEmails: '',
      weeklyDay: null,
      weeklyHour: null,
      monthlyEmails: '',
      monthlyDay: null,
      monthlyHour: null,
      // In firefox, when changing the time by code the input was not being updated, use this to have unique keys
      // and force update of the component
      refreshableKey: 0
    }
  },
  computed:
  {
    ...mapState('settings', ['settingsOutput']),
    ...mapState('settings', ['updateProgress']),
    previousDaysOptions: function()
    {
      var result = [];

      result.push({key: 1, text: "1 dia"});

      for (var i = 2; i <= 15; i++) {
        result.push({key: i, text: i + " dias"});
      }

      return result;
    },
    dayOfWeekOptions: function()
    {
      return [
        {key: 1, text: "Domingo"},
        {key: 2, text: "Segunda-Feira"},
        {key: 3, text: "Terça-Feira"},
        {key: 4, text: "Quarta-Feira"},
        {key: 5, text: "Quinta-Feira"},
        {key: 6, text: "Sexta-Feira"},
        {key: 7, text: "Sábado"},
      ];
    },
    savedMaxDays: function()
    {
      return this.settingsOutput && this.settingsOutput.obj ? this.settingsOutput.obj.maxDays : 0;
    },
    savedWeeklyDay: function()
    {
      var result = null;

      if(this.summaries.length)
      {
        var weeklySummary = this.summaries.find(summary => summary.id == 2);
        result = weeklySummary.dayOfWeek;
      }

      return result;
    },
    savedMonthlyDay: function()
    {
      var result = null;

      if(this.summaries.length)
      {
        var monthlySummary = this.summaries.find(summary => summary.id == 3);
        result = monthlySummary.dayOfWeek;
      }

      return result;
    },
    summaries: function()
    {
      return this.settingsOutput && this.settingsOutput.obj ? this.settingsOutput.obj.summaries : [];
    }
  },
  methods: {
    ...mapActions('settings', ['getSettings']),
    ...mapActions('settings', ['editSettings']),
    previousDaysChanged(val)
    {
      this.previousDays = val ? val.key : null;
    },
    weeklyDayChanged(val)
    {
      this.weeklyDay = val ? val.key : null;
    },
    monthlyDayChanged(val)
    {
      this.monthlyDay = val ? val.key : null;
    },
    submitClicked()
    {
      this.loading = true;

      // Build object
      var dailySummary = new Summary(1, Boolean(this.dailyEmails && this.dailyHour), null, this.dailyHour, this.dailyEmails);
      var weeklySummary = new Summary(2, Boolean(this.weeklyEmails && this.weeklyDay && this.weeklyHour), this.weeklyDay, this.weeklyHour, this.weeklyEmails);
      var monthlySummary = new Summary(3, Boolean(this.monthlyEmails && this.monthlyDay && this.monthlyHour), this.monthlyDay, this.monthlyHour, this.monthlyEmails);
      
      var input = new InputSettings([dailySummary, weeklySummary, monthlySummary], this.previousDays);
      this.editSettings(input);
    }
  },
  mounted: function()
  {
    this.getSettings();
  },
  watch:
  {
    settingsOutput: function()
    {
      this.previousDays = this.maxDays;

      if(this.summaries.length)
      {
        var dailySummary = this.summaries.find(summary => summary.id == 1);
        this.dailyEmails = dailySummary.emails.join(",");
        this.dailyHour = `${dailySummary.hour}:00`;

        var weeklySummary = this.summaries.find(summary => summary.id == 2);
        this.weeklyEmails = weeklySummary.emails.join(",");
        this.weeklyDay = weeklySummary.dayOfWeek;
        this.weeklyHour = `${weeklySummary.hour}:00`;     

        var monthlySummary = this.summaries.find(summary => summary.id == 3);
        this.monthlyEmails = monthlySummary.emails.join(",");
        this.monthlyDay = monthlySummary.dayOfWeek;
        this.monthlyHour = `${monthlySummary.hour}:00`;
      }
    },
    updateProgress: function(val)
    {
      if(val !== undefined)
      {
        this.loading = false;

        if(val)
        {
          alert("Definições gravadas com sucesso!");
        }
        else
        {
          alert("Houve um erro ao gravar as definições. Por favor, valide a informação inserida.");
        }
      }
    },
    // Guarantee that the input time is hours only (in some browsers, the support for the input time is not ideal, like in Firefox)
    dailyHour: function(val)
    {
      var timeParts = val.split(":");
      if(timeParts[1] != "00")
      {
        this.dailyHour = `${timeParts[0]}:00`;
        this.refreshableKey += 1;
      }
    },
    weeklyHour: function(val)
    {
      var timeParts = val.split(":");
      if(timeParts[1] != "00")
      {
        this.weeklyHour = `${timeParts[0]}:00`;
        this.refreshableKey += 1;
      }
    },
    monthlyHour: function(val)
    {
      var timeParts = val.split(":");
      if(timeParts[1] != "00")
      {
        this.monthlyHour = `${timeParts[0]}:00`;
        this.refreshableKey += 1;
      }
    }
  }
}
</script> 
 
<style scoped>
/deep/#dropdown-menu-link-1,
/deep/#dropdown-menu-link-2,
/deep/#dropdown-menu-link-3
{
  background-color: white !important;
}

.not-active-label
{
  font-size: 10px;
}

.not-active-label span
{
  font-size: 12px;
}
</style> 